<template>
  <div class="bg">
    test1
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>

<style scoped>
  .bg {
    margin-top: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/test1.vue